import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { Note } from '../../../shared/interface/note';
import { UserPermissions } from '../../../shared/interface/user-permissions';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../shared/services/auth.service';
import { ConfirmDialogComponent } from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { NoteService } from '../../../shared/services/note.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import {Uuid} from "../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {DocumentAddDialogComponent} from "../../documents/document-add-dialog/document-add-dialog.component";
import {FILE_TYPE_SALES_PROCESS_VERIFICATION_FORM} from "../../../shared/services/dict.service";
import {FacilityService} from "../../../shared/services/facility.service";
import {Profile} from "../../../shared/interface/profile";

@Component({
  selector: 'app-note-details-view',
  templateUrl: './note-details-view.component.html',
  styleUrls: ['./note-details-view.component.scss']
})
export class NoteDetailsViewComponent implements OnInit, OnDestroy {

  @Input() note: Observable<Note>;
  @Output() modifyClicked = new EventEmitter<void>();

  noteObject?: Note;
  userPermissions: ReplaySubject<UserPermissions>;
  profile: Profile;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private noteService: NoteService,
    private facilityService: FacilityService,
    private snack: MatSnackBar,
    private router: Router
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
      });
    this.note
      .pipe(takeUntil(this.destroyed$))
      .subscribe((note: Note) => {
        this.noteObject = note;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  downloadCertificates(): void {
    this.facilityService.downloadVeridicationSales(this.noteObject?.verificationSales.id.toString())
      .subscribe((response: Uuid) => {
        const dialogRef = this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });

        dialogRef.afterClosed().subscribe(result => {
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu dokumentów wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  addDocument(): void {
    const dialogRef = this.dialog.open(DocumentAddDialogComponent, {
      width: '55%',
      data: {
        facilitiesVerificationObject: this.noteObject?.verificationSales,
        types: [FILE_TYPE_SALES_PROCESS_VERIFICATION_FORM],
      },
    });

    dialogRef.afterClosed().subscribe(() => {
    });
  }



  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć notatkę?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.noteService.deleteNote(this.noteObject.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto notatkę', '', {duration: 2000});
            this.router.navigate(['/notatki']);
          });
      }
    });
  }
}
